import { useLineStore } from "@/stores/lineStore";
import { computed } from "vue";

export const useFavoriteBusStop = () => {
  const lineStore = useLineStore();

  const favoriteIdSet = computed(
    () => new Set(lineStore.favoriteBusStops.map((b) => b.uid))
  );

  const isFavorite = (busStopId: string): boolean => {
    return favoriteIdSet.value.has(busStopId);
  };

  return { isFavorite };
};
